<template>
  <div>
    <img v-if="imgUrl" :src="emptyImg" v-lazy='imgUrl'>
    <img v-else :src="emptyImg">    
  </div>
</template>

<script>
export default {
  name: 'lazyImg',
  props: {
    imgUrl: String
  },
  data() {
    return {
      emptyImg: process.env.VUE_APP_EMPTY_IMG
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}
</style>

